import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export const ReptileCard = ({ reptile, onWishlist, isWishlisted = false, testIdPrefix = "reptile" }) => {
  const { t, lang } = useLang();

  return (
    <div
      data-testid={`reptile-card-${reptile.id}`}
      className="group card-luxury block relative"
    >
      <Link
        to={`/reptile/${reptile.id}`}
        data-testid={`reptile-link-${reptile.id}`}
        className="block"
      >
      <div className="image-zoom relative aspect-[4/5] overflow-hidden bg-black">
        <img
          src={reptile.cover}
          alt={reptile.title}
          loading="lazy"
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" />
        {reptile.featured && (
          <div className="absolute top-3 left-3 tag-gold" data-testid={`${testIdPrefix}-featured-badge`}>
            {t("common.featured")}
          </div>
        )}
        {reptile.status !== "available" && (
          <div className="absolute top-3 left-3 tag-tech text-red-400 border-red-400/40">
            {reptile.status === "sold" ? t("common.sold") : t("common.reserved")}
          </div>
        )}
        {onWishlist && (
          <button
            data-testid={`${testIdPrefix}-wishlist-${reptile.id}`}
            onClick={(e) => { e.preventDefault(); onWishlist(reptile); }}
            className={`absolute top-3 right-3 p-2 bg-black/60 backdrop-blur border border-white/10 hover:border-[var(--monzal-gold)]/60 transition-colors ${isWishlisted ? "text-[var(--monzal-gold)]" : "text-white"}`}
          >
            <Heart size={14} fill={isWishlisted ? "currentColor" : "none"} />
          </button>
        )}
        <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
          <div className="flex flex-wrap gap-1">
            <span className="tag-tech">{reptile.species}</span>
          </div>
          <span className="tag-tech">{reptile.sex.toUpperCase()}</span>
        </div>
      </div>
      <div className="p-5">
        <div className="overline mb-2 text-[var(--monzal-text-2)]">{reptile.breeder_name}</div>
        <h3 className="font-display text-base text-white tracking-tight leading-snug">
          {reptile.title}
        </h3>
        {reptile.morph && (
          <p className="mt-2 font-mono-tech text-[11px] leading-relaxed text-[var(--monzal-gold)]/85 uppercase tracking-[0.05em] min-h-[2.2rem]" data-testid="reptile-morph">
            {reptile.morph}
          </p>
        )}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-white/5">
          <div className="font-mono-tech text-xs text-gray-400">
            {reptile.weight_g} g · {Math.round(reptile.age_months)} {t("detail.months")}
          </div>
          <div className="text-[var(--monzal-gold)] font-display font-semibold">
            ${reptile.price.toLocaleString()}
            <span className="text-gray-500 text-xs ml-1 font-mono-tech">{reptile.currency}</span>
          </div>
        </div>
      </div>
      </Link>
    </div>
  );
};

export default ReptileCard;
